import React from 'react';
import { Avatar, Button } from 'antd';
import { LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, MoonOutlined, SunOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { useThemeMode } from '../../contexts/ThemeContext';
import LogoMark from '../../assets/logo-mark.png';
import './index.css';

const Header = ({ collapsed, onToggle }) => {
  const { user, logout } = useAuth();
  const { themeMode, toggleThemeMode } = useThemeMode();

  const getRoleText = (role) => {
    const roleMap = {
      admin: '管理员',
      master: '师傅',
      service: '客服'
    };
    return roleMap[role] || role || '账号';
  };

  return (
    <header className="app-header">
        <div className="header-left">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={onToggle}
            className="menu-toggle"
          />
        </div>

        <div className="header-right">
          <Button
            type="text"
            className="theme-toggle"
            icon={themeMode === 'dark' ? <SunOutlined /> : <MoonOutlined />}
            onClick={toggleThemeMode}
          >
            {themeMode === 'dark' ? '亮色' : '暗色'}
          </Button>

          <div className="user-info">
            <span className="welcome-text">
              <span className="username">{user?.username}</span>
            </span>
            <span className="user-role">({getRoleText(user?.role)})</span>
          </div>

          <div className="header-avatar-wrap" aria-label="当前账号头像">
            <Avatar
              className="user-avatar"
              src={LogoMark}
              alt="系统logo"
              size="large"
              icon={<UserOutlined />}
            />
          </div>

          <Button
            type="text"
            className="header-logout-btn"
            icon={<LogoutOutlined />}
            onClick={logout}
          >
            退出
          </Button>
        </div>
    </header>
  );
};

export default Header;
